import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TranscriptBlockContainer from '@layout/TranscriptBlockContainer';
import { DiscussionPoint } from '@molecules';

class DiscussionPoints extends PureComponent {
  render() {
    const monologues = this.props.monologues
      .filter((monologue) => !monologue.hidden)
      .map((monologue, key) => (
        <DiscussionPoint
          key={key}
          id={key}
          person={monologue.speaker_name}
          text={monologue.value}
          timestamp={monologue.timestamp}
          type={monologue.type}
        />
      ));
    return (
      <TranscriptBlockContainer.MainContainer>
        {monologues}
        <TranscriptBlockContainer.Hr />
      </TranscriptBlockContainer.MainContainer>
    );
  }
}

DiscussionPoints.propTypes = {
  monologues: PropTypes.array.isRequired,
};

export default DiscussionPoints;



// WEBPACK FOOTER //
// ./components/organisms/DiscussionPoints.js